import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import QuickActionsSidebar from "../DistributorDashboard/QuickActionsSidebar";
import { getAdminActions, getDistributorActions } from "../../../config/actions";
import { API_URL } from "../../../config";
import "../DistributorsAdd/DistributorsAdd.css";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));

const DistributorDiscount = () => {
  const { distributor_id } = useParams();
  const navigate = useNavigate();
  const classes = useStyles();
  const user_type = localStorage.getItem("user_type");
  const userId = localStorage.getItem("user_id");

  const isAdmin = user_type === "7";
  const sidebarActions = isAdmin
    ? getAdminActions(userId)
    : getDistributorActions(userId);
  const backPath = isAdmin ? "/distributors" : "/mini-cart";

  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null);

  // Add/Edit Modal
  const [discountModal, setDiscountModal] = useState(false);
  const [editingCode, setEditingCode] = useState(null);
  const [formCode, setFormCode] = useState("");
  const [formDiscount, setFormDiscount] = useState("");
  const [formType, setFormType] = useState("flat");
  const [formStatus, setFormStatus] = useState(1);
  const [formUsageType, setFormUsageType] = useState("multiple");
  const [formExpiryDate, setFormExpiryDate] = useState("");
  const [formSaving, setFormSaving] = useState(false);
  const [formError, setFormError] = useState("");

  // Delete Modal
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  // Success Modal
  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    fetchDiscounts();
  }, [distributor_id]);

  const fetchDiscounts = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/distributor/discount/${distributor_id}`);
      const data = await res.json();
      if (data.status) setDiscounts(data.data);
    } catch (err) {
      console.error("Error fetching discounts:", err);
    } finally {
      setLoading(false);
    }
  };

  const openAddModal = () => {
    setEditingCode(null);
    setFormCode("");
    setFormDiscount("");
    setFormType("flat");
    setFormStatus(1);
    setFormUsageType("multiple");
    setFormExpiryDate("");
    setFormError("");
    setDiscountModal(true);
  };

  const openEditModal = (d) => {
    setEditingCode(d.code);
    setFormCode(d.code);
    setFormDiscount(String(d.discount));
    setFormType(d.type || "flat");
    setFormStatus(d.status !== undefined ? Number(d.status) : 1);
    setFormUsageType(d.usage_type || "multiple");
    setFormExpiryDate(
      d.expiry_date ? new Date(Number(d.expiry_date) * 1000).toISOString().slice(0, 10) : ""
    );
    setFormError("");
    setDiscountModal(true);
  };

  const handleSaveDiscount = async () => {
    setFormError("");
    if (!formCode.trim()) return setFormError("Code is required");
    if (formDiscount === "" || formDiscount === null)
      return setFormError("Discount value is required");
    if (isNaN(Number(formDiscount)) || Number(formDiscount) < 0)
      return setFormError("Enter a valid discount value");

    setFormSaving(true);
    try {
      const res = await fetch(`${API_URL}/distributor/discount/${distributor_id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          code: formCode.trim().toUpperCase(),
          discount: Number(formDiscount),
          type: formType,
          status: formStatus,
          usage_type: formUsageType,
          expiry_date: formExpiryDate
            ? Math.floor(new Date(formExpiryDate).getTime() / 1000)
            : null,
        }),
      });
      const data = await res.json();
      if (data.status) {
        setDiscountModal(false);
        setSuccessMessage("Discount code saved successfully!");
        setSuccessModal(true);
        fetchDiscounts();
      } else {
        setFormError(data.message || "Failed to save discount");
      }
    } catch (err) {
      setFormError("Network error. Please try again.");
    } finally {
      setFormSaving(false);
    }
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setDeleteModal(true);
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    try {
      const res = await fetch(`${API_URL}/distributor/discount/${deleteId}`, {
        method: "DELETE",
      });
      const data = await res.json();
      if (data.status) {
        setDeleteModal(false);
        setSuccessMessage("Discount deleted successfully!");
        setSuccessModal(true);
        fetchDiscounts();
      } else {
        alert(data.message || "Failed to delete");
      }
    } catch (err) {
      alert("Network error");
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <div className="distributors-add-container">
      <div className="distributors-add-dashboard">
        <QuickActionsSidebar
          actions={sidebarActions}
          expandedMenu={expandedMenu}
          setExpandedMenu={setExpandedMenu}
        />

        <div className="distributors-add-content">
          {/* Header */}
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="head-listing">
              <button
                onClick={() => navigate(backPath)}
                style={{
                  background: "none",
                  border: "none",
                  color: "rgb(77, 0, 77)",
                  fontWeight: "600",
                  cursor: "pointer",
                  marginBottom: "8px",
                  padding: 0,
                  fontSize: "14px",
                }}
              >
                ← Back
              </button>
              <h3>Discount Codes</h3>
              {/* <p style={{ color: "#666", margin: 0, fontSize: "13px" }}>
                Distributor ID: <strong>{distributor_id}</strong>
              </p> */}
            </div>
            <div className="add-btn">
              <button onClick={openAddModal}>+ Add Discount</button>
            </div>
          </div>

          {/* Table */}
          <div className="distributors-table-section">
            {loading ? (
              <div className="loading-state">
                <div className="loader-spinner"></div>
                <p>Loading discounts...</p>
              </div>
            ) : discounts.length === 0 ? (
              <div className="empty-state">
                <i className="fas fa-tag"></i>
                <p>No discount codes found</p>
              </div>
            ) : (
              <div className="table-wrapper">
                <table className="distributors-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Code</th>
                      <th>Discount</th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Usage Frequency</th>
                      <th>Expiry Date</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {discounts.map((d, i) => (
                      <tr key={d.id}>
                        <td>{i + 1}</td>
                        <td>
                          <span
                            style={{
                              fontFamily: "monospace",
                              fontWeight: "700",
                              color: "rgb(77, 0, 77)",
                              background: "#f3e8ff",
                              padding: "3px 8px",
                              borderRadius: "4px",
                            }}
                          >
                            {d.code}
                          </span>
                        </td>
                        <td>
                          <strong>
                            {d.type === "percent"
                              ? `${d.discount}%`
                              : `$${d.discount}`}
                          </strong>
                        </td>
                        <td>
                          <span
                            className={`user-type-badge ${
                              d.type === "percent" ? "admin" : "distributor"
                            }`}
                          >
                            {d.type === "percent" ? "Percentage" : "Flat"}
                          </span>
                        </td>
                        <td>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "3px 10px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: "600",
                              background: d.status ? "#dcfce7" : "#fee2e2",
                              color: d.status ? "#16a34a" : "#dc2626",
                            }}
                          >
                            {d.status ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <span
                            style={{
                              display: "inline-block",
                              padding: "3px 10px",
                              borderRadius: "12px",
                              fontSize: "12px",
                              fontWeight: "600",
                              background: d.usage_type === "onetime" ? "#fef9c3" : "#e0f2fe",
                              color: d.usage_type === "onetime" ? "#a16207" : "#0369a1",
                            }}
                          >
                            {d.usage_type === "onetime" ? "One-time" : "Multiple"}
                          </span>
                        </td>
                        <td style={{ fontSize: "13px" }}>
                          {d.expiry_date ? (
                            (() => {
                              const isExpired = Number(d.expiry_date) < Math.floor(Date.now() / 1000);
                              return (
                                <span
                                  style={{
                                    color: isExpired ? "#dc2626" : "#666",
                                    fontWeight: isExpired ? "600" : "400",
                                  }}
                                >
                                  {new Date(Number(d.expiry_date) * 1000).toLocaleDateString()}
                                  {isExpired ? " (Expired)" : ""}
                                </span>
                              );
                            })()
                          ) : (
                            <span style={{ color: "#666" }}>No expiry</span>
                          )}
                        </td>
                        <td style={{ fontSize: "13px", color: "#666" }}>
                          {d.created_at
                            ? new Date(d.created_at).toLocaleDateString()
                            : "—"}
                        </td>
                        <td>
                          <div className="dist-action-buttons">
                            <Tooltip
                              classes={{ tooltip: classes.customTooltip }}
                              title="Edit"
                              placement="top"
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={() => openEditModal(d)}
                                className="action-btn view-btn"
                              >
                                <i className="fa fa-pencil-square-o"></i>
                              </a>
                            </Tooltip>
                            <Tooltip
                              classes={{ tooltip: classes.customTooltip }}
                              title="Delete"
                              placement="top"
                            >
                              <a
                                href="javascript:void(0)"
                                onClick={() => openDeleteModal(d.id)}
                                className="action-btn"
                              >
                                <i className="fa fa-trash"></i>
                              </a>
                            </Tooltip>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Add / Edit Discount Modal */}
      <Modal
        isOpen={discountModal}
        toggle={() => !formSaving && setDiscountModal(false)}
        centered
      >
        <ModalHeader toggle={() => !formSaving && setDiscountModal(false)} style={{ background: "rgb(77, 0, 77)", color: "white" }}>
          <i className="fa fa-tag" style={{ marginRight: "8px" }}></i>
          {editingCode ? "Edit Discount Code" : "Add Discount Code"}
        </ModalHeader>
        <ModalBody>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div>
              <label
                style={{
                  fontWeight: "600",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                <i
                  className="fa fa-key"
                  style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}
                ></i>
                Discount Code *
              </label>
              <input
                type="text"
                value={formCode}
                onChange={(e) => setFormCode(e.target.value.toUpperCase())}
                placeholder="e.g. SUMMER20"
                disabled={!!editingCode}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  background: editingCode ? "#f5f5f5" : "white",
                  textTransform: "uppercase",
                }}
              />
              {editingCode && (
                <small style={{ color: "#888" }}>
                  Code cannot be changed — editing discount value only
                </small>
              )}
            </div>

            <div>
              <label
                style={{
                  fontWeight: "600",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                <i
                  className="fa fa-percent"
                  style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}
                ></i>
                Discount Value *
              </label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={formDiscount}
                onChange={(e) => setFormDiscount(e.target.value)}
                placeholder="e.g. 10"
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div>
              <label
                style={{
                  fontWeight: "600",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                <i
                  className="fa fa-tags"
                  style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}
                ></i>
                Discount Type
              </label>
              <select
                value={formType}
                onChange={(e) => setFormType(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="flat">Flat ($)</option>
                <option value="percent">Percentage (%)</option>
              </select>
            </div>

            <div>
              <label
                style={{
                  fontWeight: "600",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                <i
                  className="fa fa-toggle-on"
                  style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}
                ></i>
                Status
              </label>
              <select
                value={formStatus}
                onChange={(e) => setFormStatus(Number(e.target.value))}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>

            <div>
              <label
                style={{
                  fontWeight: "600",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                <i
                  className="fa fa-repeat"
                  style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}
                ></i>
                Usage Frequency
              </label>
              <select
                value={formUsageType}
                onChange={(e) => setFormUsageType(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              >
                <option value="multiple">Multiple Use</option>
                <option value="onetime">One-time Use</option>
              </select>
            </div>

            <div>
              <label
                style={{
                  fontWeight: "600",
                  marginBottom: "6px",
                  display: "block",
                }}
              >
                <i
                  className="fa fa-calendar"
                  style={{ color: "rgb(77, 0, 77)", marginRight: "6px" }}
                ></i>
                Expiry Date
              </label>
              <input
                type="date"
                value={formExpiryDate}
                onChange={(e) => setFormExpiryDate(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              />
           
            </div>

            {formError && (
              <div
                style={{
                  color: "red",
                  fontSize: "13px",
                  background: "#fff0f0",
                  padding: "8px 12px",
                  borderRadius: "6px",
                  border: "1px solid #fca5a5",
                }}
              >
                {formError}
              </div>
            )}
          </div>
        </ModalBody>
        <ModalBody
          style={{
            borderTop: "1px solid #dee2e6",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "12px 16px",
          }}
        >
          <button
            className="btn"
            style={{ background: "#ccc", color: "#333" }}
            onClick={() => setDiscountModal(false)}
            disabled={formSaving}
          >
            Cancel
          </button>
          <button
            className="btn"
            style={{ background: "rgb(77, 0, 77)", color: "white" }}
            onClick={handleSaveDiscount}
            disabled={formSaving}
          >
            {formSaving ? "Saving..." : "Save Discount Code"}
          </button>
        </ModalBody>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={deleteModal}
        toggle={() => !deleteLoading && setDeleteModal(false)}
        className="connect-box"
        centered
      >
        <ModalBody>
          <div className="deletemodal-content">
            <h6>
              <i
                onClick={() => !deleteLoading && setDeleteModal(false)}
                className="fa fa-times"
                aria-hidden="true"
              ></i>
            </h6>
            <div className="deleteCircle">
              <i className="fa fa-trash" aria-hidden="true"></i>
            </div>
            <h3>Are you sure?</h3>
            <p className="para">
              Do you really want to delete this discount code? This process
              cannot be undone.
            </p>
            <div className="butn-wrp">
              <button
                className="delete-cancel-btn"
                onClick={() => setDeleteModal(false)}
                disabled={deleteLoading}
              >
                Cancel
              </button>
              <button onClick={handleDelete} disabled={deleteLoading}>
                {deleteLoading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Success Modal */}
      <Modal
        isOpen={successModal}
        toggle={() => setSuccessModal(false)}
        centered
      >
        <ModalBody className="text-center">
          <div style={{ fontSize: "40px", color: "green" }}>✔</div>
          <h5 className="mt-2">{successMessage}</h5>
          <button
            className="btn btn-success mt-3"
            onClick={() => setSuccessModal(false)}
          >
            OK
          </button>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default DistributorDiscount;
